module.exports = __webpack_public_path__ + "img/report-income.ac7ed951.svg";